import { Text } from "react-native";
import { formatDayMonthYear } from "@heraion/shared";

import type { UiTheme } from "../theme";
import { useDateLocale } from "./DateFormatContext";

// <DateLine> - a session's day under its title (day, month, year in the
// reader's date locale). Nothing for a missing or unparseable date.
export function DateLine({ theme, iso }: { theme: UiTheme; iso: string | undefined }) {
  const locale = useDateLocale();
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return null;
  return (
    <Text style={{ color: theme.palette.ink2, fontSize: theme.typography.sizes.sm }}>
      {formatDayMonthYear(d, locale)}
    </Text>
  );
}
